import { captureResumeTokenFromUrl } from './utils/resumeTokenUtils';

// imported first by index.js so it runs before any module that reads the url at load
captureResumeTokenFromUrl();
